module.exports = __webpack_public_path__ + "img/group1805.6182bb68.svg";